import { getEventTracker } from '@libs/eventTracking'
import {
  getNextPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { paths } from '@routes/header-paths'

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-header/web-header.enter-web-pgc-article-list.md)
 */
export function trackHeaderEnterWebPgcArticleListEvent() {
  getEventTracker().track({
    name: WebEventNames.WEB_HEADER_ENTER_WEB_PGC_ARTICLE_LIST,
    properties: {
      currentPage: getCurrentPagePropertyFor(''),
      toPage: getNextPagePropertyFor({
        pageName: 'web-pgc',
        pageUrl: window.location.origin + paths.pgc,
      }),
    },
  })
}
